import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { GuestCheckoutForm } from "@nebula-ltd/pok-payments-js/react";
import "@nebula-ltd/pok-payments-js/lib/index.css";
import "./CheckoutPage.css";

export default function CheckoutPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("orderId");
  const bookid = searchParams.get("bookid");
  const amount = searchParams.get("amount");
  const [status, setStatus] = useState("idle"); // idle | success | error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(function () {
    window.scrollTo(0, 0);
    if (!orderId || !bookid) {
      navigate("/");
    }
  }, [orderId, bookid, navigate]);

  async function handleSuccess() {
    setStatus("success");
    // Notify our backend which notifies Beds24
    try {
      await fetch("/api/payments/notify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bookid, amount })
      });
    } catch (err) {
      console.error("Notify error:", err);
    }
  }

  function handleError(err) {
    console.error("POK payment error:", err);
    setErrorMsg("Payment failed. Please check your card details and try again.");
    setStatus("error");
  }

  if (!orderId) return null;

  return (
    <div className="checkout-page">
      <div className="checkout-container">

        {/* Header */}
        <div className="checkout-header">
          <div className="checkout-logo">
            <span className="checkout-logo-text">BookingAlb</span>
          </div>
          <div className="checkout-eyebrow">Secure Payment</div>
        </div>

        {status === "success" ? (
          <div className="checkout-success">
            <div className="checkout-success-icon">✓</div>
            <h2>Payment Confirmed</h2>
            <p>Your booking <strong>#{bookid}</strong> has been confirmed. You will receive a confirmation email shortly.</p>
            <button className="checkout-home-btn" onClick={() => navigate("/")}>
              Back to Home
            </button>
          </div>
        ) : (
          <>
            {/* Booking summary */}
            <div className="checkout-summary">
              <div className="checkout-summary-row">
                <span className="checkout-summary-label">Booking reference</span>
                <span className="checkout-summary-value">#{bookid}</span>
              </div>
              <div className="checkout-summary-row">
                <span className="checkout-summary-label">Amount due</span>
                <span className="checkout-summary-amount">€{parseFloat(amount).toFixed(2)}</span>
              </div>
            </div>

            {/* Error message */}
            {status === "error" && (
              <div className="checkout-error">{errorMsg}</div>
            )}

            {/* POK payment form */}
            <div className="checkout-form-wrap">
              <GuestCheckoutForm
                orderId={orderId}
                onSuccess={handleSuccess}
                onError={handleError}
                options={{ env: "production", locale: "en" }}
              />
            </div>

            <p className="checkout-secure-note">
              🔒 Payments are processed securely by POK · Powered by BookingAlb
            </p>
          </>
        )}

      </div>
    </div>
  );
}
